module.exports = __webpack_public_path__ + "img/maker-1.2a98bd6a.jpg";